import { ref } from 'vue'
import { useSubjectService } from '@/services/subject.service'

export const useValidation = () => {
  const isEmptyValue = (value) => value === null || value === undefined || value === ''

  const isValidLength11 = (code) => {
    if (!/^[0-9]{11}$/.test(code)) { return false }

    let sum = 0
    for (let i = 0; i < 11; i++) {
      let digit = parseInt(code[i], 10)
      if (i % 2 === 1) {
        digit *= 2
        if (digit > 9) {
          digit -= 9
        }
      }
      sum += digit
    }

    return sum % 10 === 0
  }

  const validateVatNumber = (value, vatCountryId) => {
    const { isVatCountryIta } = useSubjectService()

    if (isEmptyValue(value)) { return true }
    if (!isVatCountryIta(vatCountryId)) { return true }
    if (typeof value !== 'string') { return false }

    const vat = value.replace(/\s/g, '')
    if (vat.length === 0) { return true }

    return isValidLength11(vat)
  }

  const validateRequiredVatNumber = (value, vatCountryId, subjectSubTypeId) => {
    const { isVatNumberMandatory } = useSubjectService()
    if (!isVatNumberMandatory(subjectSubTypeId, vatCountryId)) {
      return true
    }
    return value !== null && value !== undefined && value !== ''
  }

  const validateTaxCode = (value, countryCode) => {
    if (countryCode !== 'ITA') { return true }
    if (isEmptyValue(value)) { return true }
    if (typeof value !== 'string') { return false }

    const normalize = (cf) => cf.replace(/\s/g, '').toUpperCase()
    const evenMap = 'BAFHJNPRTVCESULDGIMOQKWZYX'

    const taxCode = normalize(value)

    if (taxCode.length === 0) { return true }
    if (taxCode.length === 11) { return isValidLength11(taxCode) }

    if (taxCode.length !== 16) {
      return false
    }

    const regex = /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/
    if (!regex.test(taxCode)) {
      return false
    }

    let sum = 0
    for (let i = 0; i < 15; i++) {
      const char = taxCode[i]
      let n = 0

      if (char >= '0' && char <= '9') {
        n = char.charCodeAt(0) - '0'.charCodeAt(0)
      } else {
        n = char.charCodeAt(0) - 'A'.charCodeAt(0)
      }

      if (i % 2 === 0) {
        n = evenMap.charCodeAt(n) - 'A'.charCodeAt(0)
      }

      sum += n
    }

    const expectedControlChar = String.fromCharCode((sum % 26) + 'A'.charCodeAt(0))
    return taxCode[15] === expectedControlChar
  }

  return {
    validateVatNumber,
    validateRequiredVatNumber,
    validateTaxCode
  }
}

export const useValidationTabs = () => {
  const validationTabIndexErrors = ref([])

  const onTabsValidating = (e) => {
    validationTabIndexErrors.value = []
    if (!e.isValid) {
      for (const brokenRule of e.brokenRules) {
        const editor = brokenRule.validator.option('adapter').editor
        const tabIndex = editor.option('validationTabIndex') || editor.option('tabIndex')
        if (tabIndex !== undefined && !validationTabIndexErrors.value.includes(tabIndex)) {
          validationTabIndexErrors.value.push(tabIndex)
        }
      }
    }
  }
  return { validationTabIndexErrors, onTabsValidating }
}
